import React, { type ReactNode } from 'react';

import Content from './Content';
import RulesProvider from './Context';

import type { SupportRule, SearchableConfig } from '../TableIndex';

interface RulesProps {
  supportRules?: SupportRule[];
  searchable?: boolean | SearchableConfig;
  tableId: string;
  lastModified?: number;
  filterHelpExample?: string;
  filterDocsUrl?: string;
  searchTooltipContent?: ReactNode;
  newPath?: string;
  onCreate?: () => void;
  onImportClick?: () => void;
  testIdPrefix?: string;
}

const Rules: React.FC<RulesProps> = ({
  supportRules,
  searchable,
  tableId,
  lastModified,
  filterHelpExample,
  filterDocsUrl,
  searchTooltipContent,
  newPath,
  onCreate,
  onImportClick,
  testIdPrefix,
}) => {
  return (
    <RulesProvider>
      <Content
        supportRules={supportRules}
        tableId={tableId}
        searchable={searchable}
        lastModified={lastModified}
        filterHelpExample={filterHelpExample}
        filterDocsUrl={filterDocsUrl}
        searchTooltipContent={searchTooltipContent}
        newPath={newPath}
        onCreate={onCreate}
        onImportClick={onImportClick}
        testIdPrefix={testIdPrefix}
      />
    </RulesProvider>
  );
};

export default Rules;
